<template>
  <v-card title="对账单查询">
    <div class="grid-demo">
       <v-more-panel>
        <v-form slot="form">

          <v-form-item label="业务日期">
            <v-date-picker v-model="options.ywrqq"></v-date-picker>
             -
            <v-date-picker v-model="options.ywrqz" ></v-date-picker>
          </v-form-item>

           <v-form-item label="导入日期">
            <v-date-picker v-model="options.drrqq"></v-date-picker>
             -
            <v-date-picker v-model="options.drrqz" ></v-date-picker>
          </v-form-item>

           <v-form-item label="付款方式"
            >
            <v-radio-group v-model="options.fkfs" :data="pay_type" ></v-radio-group>
           </v-form-item>

         <v-form-item label="EMS区域"
            ><v-select
              style="width: 100px"
              v-model="options.qy"
               :data="qy_options"
            ></v-select
          ></v-form-item>

          <v-form-item label="护照状态"
            >
            <v-radio-group v-model="options.hzzt" :data="hz_state" ></v-radio-group>
            </v-form-item>

             <v-form-item label="业务流水号"> 
             <v-input placeholder="" v-model="options.ywdh"></v-input>
            </v-form-item>

            <v-form-item label="用户ID"> 
             <v-input placeholder="" v-model="options.uid"></v-input>
            </v-form-item>
            
        </v-form>
        <v-form-item
        <v-button slot="control" type="primary"  icon="search"  @click="findList('1')">查询</v-button>
        </v-form-item>
      </v-more-panel>
    </div>
    <br />
    <vxe-grid
      v-bind="xGridOptions"
      size="mini"
      stripe
      highlight-current-row
      highlight-hover-row
      ref="xTable"
      :data="tableData"
      :loading="loading"
      row-id="gh"
    >
   
      <template v-slot:empty>
        <span style="color: red">
          <p>未搜索到结果！</p>
        </span>
      </template>
    </vxe-grid>
    <vxe-pager
      :current-page="pagination.pageindex"
      :page-size="pagination.pagesize"
      :total="pagination.totalresult"
      :layouts="[
        'PrevPage',
        'JumpNumber',
        'NextPage',
        'FullJump',
        'Sizes',
        'Total',
      ]"
      @page-change="handlePageChange"
    ></vxe-pager>
  </v-card>
</template>
<script>
let options = {
  ywrqq:"",
  ywrqz:"",
  drrqq:"",
  drrqz:"",
  fkfs:"0",
  qy: "全部",
  hzzt:"0",
  ywdh:"",
  uid:""
};
let pagination = {
  // sort: "gh",
  // sorttype: "desc",
  pagesize: 10,
  pageindex: 1,
  totalresult: 1
};

let pay_type = [{ value: '0', text: '全部' }, { value: '1', text: '中信银行' }, { value: '2', text: 'EMS邮政' }];
let hz_state = [{ value: '0', text: '全部' }, { value: 'Picked Up', text: 'Picked Up' }, { value: 'returned to post', text: 'returned to post' }];
let qy_options = [{value: "全部",label: "全部"},{value: "上海",label: "上海"},{value: "北京",label: "北京"},{value: "广州",label: "广州"},{value: "沈阳",label: "沈阳"},{value: "武汉",label: "武汉"}]
export default {
  data() {
    return {
      hz_state,
      pay_type,
      qy_options,
      options,
      pagination,
      loading:false,
      tableData: [],
      visible: false,
      message: "",
      xGridOptions: {
        showOverflow: true,
        resizable: true,
        height: document.documentElement.clientHeight - 220,
        headerAlign: "center",
         toolbarConfig: {
         
          export: true,
          zoom: true,
          custom: true
        },
         exportConfig: {
          remote: true,
          exportMethod: this.exportMethod,
          types: ['xlsx'],
          modes: ['current']
        },

        columns: [
          {
            field: "rn",
            title: "序号",
            width: 70,
            align: "center"
          },

          {
            field: "ywdh",
            title: "业务流水号",
            align: "center",
            width: 200
          },
          {
            field: "uid",
            title: "用户ID",
            align: "center",
          },
          {
            field: "je",
            title: "金额",
            align: "right",
            formatter:"formatNumber"
          },
          {
            field: "ywrq",
            title: "业务日期",
            align: "center"
          },
           {
            field: "rq",
            title: "导入日期",
            align: "center"
          },
          {
            field: "hzzt",
            title: "护照状态",
            align: "center",
          },
          {
            field: "qy",
            title: "区域",
            align: "center",
          },
        ]
      }
    };
  },
  created() {
    this.findList();
  },
  methods: {
    
    findList(index) {
      this.loading = true
      if (index == "1") {
        this.pagination.pageindex = 1;
      }
      this.$axios
        .get(
          "api/system/interface/dzdcx?cx=" + JSON.stringify(this.options), { params: this.pagination }
        )
        .then(res => {
          // debugger
          this.tableData = res.data.data
          this.pagination.totalresult = res.data.total;
          this.loading = false
        });
    },
   
    handlePageChange({ currentPage, pageSize }) {
      this.pagination.pageindex = currentPage;
      this.pagination.pagesize = pageSize;
      this.findList();
    },
   
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
     exportMethod({ options }) {

       
      this.$axios({method:'get',url:'api/system/interface/export-file?sheetname='+options.sheetName +'&cx=' + 
      JSON.stringify(this.options)+'&pageindex='+this.pagination.pageindex+'&pagesize='+this.pagination.pagesize, responseType:'blob'}).then((res) => {
        debugger
        let blob = new Blob([res.data], { type: "application/vnd.ms-excel;charset=utf-8;" });
        var downloadElement = document.createElement("a");
        var href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download=options.filename+".xlsx"; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
       this.spinning = false

      });
      // require.ensure([], () => {

      //   let { export_json_to_excel } = require('./Export2Excel.js')
      //   let header = options.columns.map(function (el) {
      //     return el.title;
      //   })
      //   let filterVal = options.columns.map(function (el) {
      //     return el.property;
      //   })
      //   let data = this.formatJson(filterVal, options.data);
      //   export_json_to_excel(header, data, options.filename, options.sheetName);
      // })
    }
  }
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/view/ywgl/dzdcx.vue